import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AuthService } from '../views/auth/auth.service';

@Component({
  selector: 'app-invitation-dialog',
  templateUrl: './invitation-dialog.component.html',
  styleUrls: ['./invitation-dialog.component.css']
})
export class InvitationDialogComponent {
 email: string = '';
emailAdmin=localStorage.getItem('email');
  constructor(
    public dialogRef: MatDialogRef<InvitationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private contactService: AuthService
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSend(): void {
    // Perform send email logic here
console.log ("test email user ", this.email )
    this.contactService.addInvitation(this.emailAdmin,this.email).subscribe(
      data => {
    
         console.log("ffff")
  
         this.dialogRef.close();

      },
      error => {
console.log(error)
      
       }
    );
  
  }
}
